<!--
    描述：角色添加
    日期：2021/04/08
    作者：zwh
-->
<template>
    <div>
        <el-form
                :model="objectForm"
                :rules="formRules"
                ref="objectForm"
                label-width="120px"
        >
            <el-row>
                <el-col :span="24">
                    <el-form-item label="角色名称" prop="roleName" :show-message="false">
                        <el-input
                                v-model="objectForm.roleName"
                                autocomplete="off"
                                :disabled="isDisabled"
                                :show-message="false"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="角色类型">
                <el-input
                        v-model="objectForm.typeName"
                        autocomplete="off"
                        disabled
                        :show-message="false"
                ></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="主体类型">
                        <el-select v-model="objectForm.limitId" :disabled="roleType !== 1" placeholder="请选择">
                            <el-option
                                    v-for="item in limits"
                                    :key="item.id"
                                    :label="item.sname"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="主体管理员" v-show="radioShow">
                <el-radio-group v-model="objectForm.isAdmin" :disabled="roleType===0">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注信息" prop="remark" :show-message="false">
                        <el-input
                                type="textarea"
                                v-model="objectForm.remark"
                                autocomplete="off"
                                :disabled="isDisabled"
                                :show-message="false"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {getLimits} from "api/unitMaintain/unit";
    import {saveOrUpdatePlus, getInfoById} from "api/system/role";
    import {mapState} from 'vuex';

    export default {
        name: "",
        props: {
            mode: {
                type: String,
                default: "add",
            },
            transObj: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },
        data() {
            return {
                //角色类型
                roleTypeSelectList: [],
                limits: [],
                btnLoading: false,
                objectForm: {
                    id: '',
                    limitId: '',//主体类型
                    parentId: '',  //父角色id
                    parentName: '',//父角色名称
                    roleName: '',   //角色名称
                    roleType: '',  //角色类型
                    isAdmin: 0, // 是否是管理员
                    remark: '',
                    typeName: ''
                },
                formRules: {
                    roleName: [{required: true, message: '请输入...', trigger: 'blur'}],
                    roleType: [{required: true, message: '请选择...', trigger: 'change'}],
                    sortNum: [{required: true, message: '请输入...', trigger: 'blur'}],
                },
                radioShow: false
            }
        },
        computed: {
            // 是否可编辑
            isDisabled() {
                return this.mode === 'view' ? true : false
            },
            ...mapState("user", {
                roleType: (state) => state.userInfo.roleType, // 1 是超级管理员  0 是普通
            }),
        },
        created() {
            //赋值
            this.objectForm.id = this.transObj.id;
            this.objectForm.parentId = this.transObj.parentId;
            this.objectForm.roleType = this.roleType === 1 ? '1003001' : '1003002';
            this.objectForm.limitId = this.roleType === 0 ? this.$getSessionItem('limitId') : '';
            this.objectForm.typeName = this.roleType === 1 ? "项目外公共角色" : "项目外主体私有角色";
            //编辑/修改/查看等
            if (this.objectForm.id != "") this.getObjectById();
            this.getLimits();
        },
        methods: {
            //根据id，获取角色信息
            getObjectById() {
                let param = {id: this.objectForm.id + ""};
                getInfoById(param).then((res) => {
                    if (res.operationCode == 1) {
                        res.data != null && res.data != ""
                            ? (this.objectForm = res.data)
                            : "";
                    }
                });
            },
            //点击确定按钮事件
            doSave() {
                let that = this;
                this.$refs["objectForm"].validate((valid) => {
                    if (valid) {
                        let param = this.objectForm;
                        saveOrUpdatePlus(param).then((res) => {
                            if (res.operationCode == 1) {
                                if (res.msg == "faild") {
                                    that.$message({message: res.data, type: "error"});
                                    return;
                                }
                                that.$message({message: "保存成功", type: "success"});
                                //刷新
                                that.$emit("handle-success");
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },

            // 关闭弹窗事件
            handleClose() {
            },

            getLimits() {
                getLimits().then((res) => {
                    this.limits = res.data;
                });
            },
        },
        computed: {
            ...mapState("user", {
                roleType: (state) => state.userInfo.roleType, // 1 是超级管理员  0 是普通
            }),
            // 是否可编辑
            isDisabled() {
                return this.mode === "view" ? true : false;
            },
        },
        watch: {
            "objectForm.limitId": {
                handler: function (val) {
                    this.radioShow = val;
                    if (val) {
                        this.objectForm.typeName = this.roleType === 0 ? '项目外主体私有角色' : '项目外主体公共角色';
                    } else {
                        this.objectForm.typeName = '项目外公共角色'
                    }
                },
                deep: true,
            },
        },
    };
</script>
<style lang="less"></style>
